import React from 'react';
import { Page, View, Document, Image, StyleSheet, Text } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';

Font.register({
  family: 'NotoSansJP',
  src: '/fonts/NotoSansJP-Regular.ttf',
});

// サイズ設定
const LABEL_WIDTH_PT = 119.06;
const LABEL_HEIGHT_PT = 82.2;

const styles = StyleSheet.create({
  page: {
    width: LABEL_WIDTH_PT,
    height: LABEL_HEIGHT_PT,
    fontFamily: 'NotoSansJP',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    backgroundColor: 'white',
  },
  janlabels_name: {
    fontSize: 6,
    width: 100,
    height: 24,  
    textAlign: 'center',
    color: '#000',
    lineHeight: 1,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
    justifyContent: 'flex-end',
  },
  barcode_image: {
    width: 100,    // 適宜調整
    height: 33,       // 適宜調整
    objectFit: 'contain',
  },
  janlabels_barcode: {
    fontSize: 10,
    width: 100,
    textAlign: 'center',
    color: '#000',
    marginTop: 2,
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
  },
});

const BarcodePdfDocument = ({ barcodeItems }) => (
  <Document>
    {barcodeItems.map((item) =>
      Array.from({ length: item.number || 1 }).map((_, idx) => (
        <Page
          key={`${item.id}-${idx}`}
          size={{ width: LABEL_WIDTH_PT, height: LABEL_HEIGHT_PT }}
          style={styles.page}
        >
          <View>
             <View>
              <Text style={styles.janlabels_name}>
                {item.label_item_id?.item_name || "NO-NAME"}
              </Text>
            </View>
            <Image
              src={item.barcodeImage || ''}
              style={styles.barcode_image}
            />
            <View>
              <Text style={styles.janlabels_barcode}>
                {item.label_item_id?.jan || "NO-JAN"}
              </Text>
            </View>
          </View>
        </Page>
      ))
    )}
  </Document>
);

export default BarcodePdfDocument;
